/* eslint-disable complexity */
import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import styles from './PriceInfo.module.scss';

type UltrapackPrice = {
  formattedPrice: string;
  geoTaxDisclosure?: string | null;
};

const UltrapackPriceInfo = ({
  formattedPrice,
  geoTaxDisclosure,
}: UltrapackPrice) => {
  const t = useTranslations();

  return (
    <div
      className={styles.saveWithUltraPack}
      data-testid="ultra-pack-price"
    >
      <div className={styles.ultraPackPrice}>
        {formattedPrice}
        {geoTaxDisclosure ? (
          <span
            className={styles.geoTax}
            data-testid="geo-tax-disclosure"
          >
            {geoTaxDisclosure}
          </span>
        ) : null}
      </div>
      <div className={styles.ultraPriceDescription}>{t('per_download')}</div>
    </div>
  );
};

export default UltrapackPriceInfo;
